import nevi from "./img/nevi.png";
import pvalley from "./img/pvalley.png";
import higherlife from "./img/higherlife.png";
import project from "./img/project1.jpg";
import project2 from "./img/project2.jpg";
import project3 from "./img/project3.jpg";
export const products = [
  {
    id: 1,
    img: nevi,
    link: "https://www.shop-nevi.com/#/",
  },
  {
    id: 2,
    img: pvalley,
    link: "https://pleasantvalleyluxuryvillas.business.site/",
  },
  {
    id: 3,
    img: higherlife,
    link: "https://www.higherlifefoundation.com/ ",
  },
  {
    id: 4,
    img: project,
    link: "#",
  },
  {
    id: 5,
    img: project2,
    link: "#",
  },
  {
    id: 6,
    img: project3,
    link: "#",
  },
];
